import { Checkbox, FormGroup } from "@mui/material";

export const BasicFormikCheckbox = ({ field, fieldId, formik, disabled }) => {
  const label = field.spec.label;
  const key = fieldId;

  return (
    <>
      <FormGroup
        key={key}
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}>
        <Checkbox
          name={key}
          id={key}
          checked={formik.values[key]}
          onChange={(e) => {
            formik.setFieldValue(key, e.target.checked);
          }}
          disabled={disabled}
        />
        {label}
      </FormGroup>
    </>
  );
};
